module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\"><path id=\"icon-home@2x-a\" d=\"M21,13 L19,13 L19,13 C18.4477153,13 18,13.4477153 18,14 L18,20 L14,20 L14,15 L14,15 C14,14.4477153 13.5522847,14 13,14 L11,14 L11,14 C10.4477153,14 10,14.4477153 10,15 L10,20 L6,20 L6,14 L6,14 C6,13.4477153 5.55228475,13 5,13 L3,13 L12,4 L21,13 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/home.svg
// module id = 756
// module chunks = 0